export let routes = [
    {
      path: '/x3-side-tuifei-class',
      name: 'x3-side-tuifei-class',
      component: () => import('@x3/js/side/tuifei/tuifei-class.vue'),
      meta: {
        vx_animate: 'none',
      },
    },
    {
      path: '/x3-side-tuifei-goods',
      name: 'x3-side-tuifei-goods',
      component: () => import('@x3/js/side/tuifei/tuifei-goods.vue'),
      meta: {
        vx_animate: 'none',
      },
    },
    {
      path: '/x3-side-tuifei-card',
      name: 'x3-side-tuifei-card',
      component: () => import('@x3/js/side/tuifei/tuifei-card.vue'),
      meta: {
        vx_animate: 'none',
      },
    },
    {
      path: '/x3-side-tuifei-online',
      name: 'x3-side-tuifei-online',
      component: () => import('@x3/js/side/tuifei/tuifei-online.vue'),
      meta: {
        vx_animate: 'none',
      },
    },
  ];
  
  export let api = {
    xsTuifeiClass(options) {
      return new Promise((resolve, reject) => {
        app.router.push(
          '/x3-side-tuifei-class',
          route => {
            route.meta._resolve = resolve;
            route.meta._reject = reject;
            route.meta.options = options;
          },
          err => {
            console.log(err);
          }
        );
      });
    },
    xsTuifeiGoods(options) {
      return new Promise((resolve, reject) => {
        app.router.push(
          '/x3-side-tuifei-goods',
          route => {
            route.meta._resolve = resolve;
            route.meta._reject = reject;
            route.meta.options = options;
          },
          err => {
            console.log(err);
          }
        );
      });
    },
    xsTuifeiCard(options) {
      return new Promise((resolve, reject) => {
        app.router.push(
          '/x3-side-tuifei-card',
          route => {
            route.meta._resolve = resolve;
            route.meta._reject = reject;
            route.meta.options = options;
          },
          err => {
            console.log(err);
          }
        );
      });
    },
    xsTuifeiOnline(options) {
      return new Promise((resolve, reject) => {
        app.router.push(
          '/x3-side-tuifei-online',
          route => {
            route.meta._resolve = resolve;
            route.meta._reject = reject;
            route.meta.options = options;
          },
          err => {
            console.log(err);
          }
        );
      });
    },
  };
  